import _ from 'lodash';
import { createReducer } from '../../../../common/reduxHelpers';
import * as types from './actionTypes';
import * as selectors from './selectors';
import { utcToDisplayDate } from '../../../../common/formatting';
import { setIn, mergeIn } from 'immutable-light';

export const emptyAddHardware = {
    box: {
        isLoading: false,
        list: [],
        serialNumber: '',
        isValid: true,
        isBundled: false,
        notEligibleToMove: false,
        addHardwareInfo: {}
    },
    card: {
        isLoading: false,
        list: [],
        serialNumber: '',
        isValid: true,
        isBundled: false,
        notEligibleToMove: false,
        addHardwareInfo: {}
    },
    isLoading: false,
    isBundledHardware: false,
    isSuccessful: true,
};

export const initialState = {
    productsList: [],
    isLoading: false,
    saving: false,
    addHardware: emptyAddHardware,
    serials: {},
    search: {}
};

const mapHardware = hardware => (({ serialNumber, name }) => ({ serialNumber, name }))(hardware)

const reducer = createReducer(initialState, {

    [types.UPDATE_SERIAL]: (state, action) => setIn(state, ['serials', action.agreementDetailsId, action.key], action.serialNumber),
    [types.RESET_SEARCH]: (state, action) => mergeIn(state, [], { search: {}, serials: {}}),
    [types.SEARCH_SERIAL_REQUEST]: (state, action) => setIn(state, ['search', action.data.serialNumber, 'status'], 'loading'),
    [types.SEARCH_SERIAL_SUCCESS]: (state, action) => mergeIn(state, ['search', action.data.serialNumber], { status: 'loaded', result: action.response[0] }),
    [types.SEARCH_SERIAL_FAILURE]: (state, action) => setIn(state, ['search', action.data.serialNumber, 'status'], 'failed'),
    [types.SAVE_START]: (state, action) => setIn(state, ['saving'], true),
    [types.SAVE_STOP]: (state, action) => setIn(state, ['saving'], false),

    [types.FETCH_HARDWARE_PRODUCTS_SUCCESS](state, action) {
        let productsList = action.response.map(product => _.assign({}, product, { isLoadingWarranty: true, isLoadingSmb2FirmwareVersion: true }));
        return _.assign({}, state, {
            productsList: [...productsList],
            isLoading: false,
        });
    },

    [types.FETCH_HARDWARE_PRODUCTS_REQUEST](state, action) {
        return _.assign({}, state, {
            productsList: [],
            isLoading: true,
        });
    },

    [types.FETCH_HARDWARE_PRODUCTS_FAILURE](state, action) {
        return _.assign({}, state, {
            productsList: [],
            isLoading: false,
        });
    },
    [types.SET_HARDWARE_SERIAL_NUMBER](state, action) {
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                box: _.assign({}, state.addHardware.box, {
                    serialNumber: action.serialNumber,
                    isValid: action.isValid,
                    list: [],
                    notEligibleToMove: false,
                    isBundled: false                    
                })
            })
        });
    },
    [types.SET_CARD_SERIAL_NUMBER](state, action) {
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                card: _.assign({}, state.addHardware.card, {
                    serialNumber: action.serialNumber,
                    isValid: action.isValid,
                    list: [],
                    notEligibleToMove: false,
                    isBundled: false
                })
            })
        });
    },
    [types.FETCH_HARDWARE_DEVICE_BY_SERIAL_REQUEST](state, action) {
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                box: _.assign({}, state.addHardware.box, {
                    list: [],
                    isLoading: true
                })
            })
        });
    },
    [types.FETCH_HARDWARE_DEVICE_BY_SERIAL_SUCCESS](state, action) {
        const device = action.response[0];
        let isBundled = device ? device.isBundled : false;
        let isBundledDeviceAttached = device ? device.bundledDevices.length > 0 : false;
        let cardDataList = state.addHardware.card.list;
        let cardSerial = state.addHardware.card.serialNumber;
        let cardAddHardwareInfo = state.addHardware.card.addHardwareInfo
        let isCardSerialValid = state.addHardware.card.isValid;
        let cardIsBundled = state.addHardware.card.isBundled;
        if (isBundled && isBundledDeviceAttached) {
            cardDataList = device.bundledDevices.map(mapHardware);
            cardSerial = device.bundledDevices[0].serialNumber;
            isCardSerialValid = true;
            cardIsBundled = device.bundledDevices[0].isBundled;
            cardAddHardwareInfo = device.bundledDevices[0].addHardwareInfo;
        }
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                box: _.assign({}, state.addHardware.box, {
                    list: action.response.map(mapHardware),
                    isLoading: false,
                    notEligibleToMove: false,
                    addHardwareInfo: device? device.addHardwareInfo: {},
                    isBundled
                }),
                card: _.assign({}, state.addHardware.card, {
                    list: cardDataList,
                    serialNumber: cardSerial,
                    isValid: isCardSerialValid,
                    addHardwareInfo: cardAddHardwareInfo,
                    isBundled: cardIsBundled
                }),
                isBundledHardware: isBundled
            })
        });
    },
    [types.FETCH_HARDWARE_DEVICE_BY_SERIAL_FAILURE](state, action) {
        const errorCode = action.error.response.status;
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                box: _.assign({}, state.addHardware.box, {
                    list: [],
                    isLoading: false,
                    addHardwareInfo: {},
                    notEligibleToMove: errorCode === 409
                })
            })

        });
    },
    [types.FETCH_CARD_DEVICE_BY_SERIAL_REQUEST](state, action) {
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                card: _.assign({}, state.addHardware.card, {
                    list: [],
                    addHardwareInfo: {},
                    isLoading: true,
                    notEligibleToMove: false
                })
            })
        });
    },

    [types.FETCH_CARD_DEVICE_BY_SERIAL_SUCCESS](state, action) {
        const device = action.response[0];
        let isBundled = device ? device.isBundled : false;
        let isBundledDeviceAttached = device ? device.bundledDevices.length > 0 : false;
        let hardwareDataList = state.addHardware.box.list;
        let boxAddHardwareInfo = state.addHardware.box.addHardwareInfo;
        let hardwareSerial = state.addHardware.box.serialNumber;
        let isHardwareSerialValid = state.addHardware.box.isValid;
        let hardwareIsBundled = state.addHardware.box.isBundled;
        if (isBundled && isBundledDeviceAttached) {
            hardwareDataList = device.bundledDevices.map(mapHardware);
            hardwareSerial = device.bundledDevices[0].serialNumber;
            isHardwareSerialValid = true;
            hardwareIsBundled = device.bundledDevices[0].isBundled;
            boxAddHardwareInfo = device.bundledDevices[0].addHardwareInfo;
        }
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                box: _.assign({}, state.addHardware.box, {
                    list: hardwareDataList,
                    isValid: isHardwareSerialValid,
                    serialNumber: hardwareSerial,
                    addHardwareInfo: boxAddHardwareInfo,
                    isBundled: hardwareIsBundled
                }),
                card: _.assign({}, state.addHardware.card, {
                    list: action.response.map(mapHardware),
                    isLoading: false,
                    notEligibleToMove: false,
                    addHardwareInfo: device.addHardwareInfo,
                    isBundled
                }),
                isBundledHardware: isBundled
            })
        });
    },

    [types.FETCH_CARD_DEVICE_BY_SERIAL_FAILURE](state, action) {
        const errorCode = action.error.response.status;
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                card: _.assign({}, state.addHardware.card, {
                    list: [],
                    isLoading: false,
                    addHardwareInfo: {},
                    notEligibleToMove: errorCode === 409
                })
            })
        });
    },
    [types.ADD_HARDWARE_PRODUCT_CLEAR](state, action) {
        return _.assign({}, state, {
            addHardware: emptyAddHardware,
        });
    },
    [types.CANCEL_HARDWARE_PRODUCT_CLEAR](state, action) {
        return _.assign({}, state, {
            productsList: state.productsList.map(product => _.assign({}, product, { isToCancel: false }))
        });
    },
    [types.TOGGLE_PRODUCT_TO_CANCEL_FLAG](state, action) {
        const hardwareList = state.productsList;
        hardwareList.forEach(function (element) {
            if (element.commercialProductAgreementDetailId === action.agreementDetailId)
                element.isToCancel = !element.isToCancel;
        }, this);

        return _.assign({}, state, { productsList: [...hardwareList] });
    },
    [types.ADD_HARDWARE_PRODUCT_REQUEST](state, action) {
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                isLoading: true,
                isSuccessful: false
            })
        });
    },
    [types.ADD_HARDWARE_PRODUCT_SUCCESS](state, action) {
        return _.assign({}, state, {
            addHardware: emptyAddHardware,
        });
    },
    [types.ADD_HARDWARE_PRODUCT_FAILURE](state, action) {
        return _.assign({}, state, {
            addHardware: _.assign({}, state.addHardware, {
                isLoading: false,
                isSuccessful: false
            })
        });
    },
    [types.FETCH_HARDWARE_DEVICE_DETAILS_BY_SERIAL_SUCCESS](state, action) {
        const hardwareList = state.productsList.map(element => {
            if (element.serialNumber === action.response.serialNumber) {
                let purchaseDate = new Date(action.response.firstPurchaseTime);
                purchaseDate.setMonth(purchaseDate.getMonth() + 3);
                purchaseDate.setFullYear(purchaseDate.getFullYear() + 5);
                return _.assign({}, element, {
                    warrantyDate: utcToDisplayDate(purchaseDate),
                    firstPurchaseDate: utcToDisplayDate(action.response.firstPurchaseTime),
                    guaranteeResponsibleName: action.response.guaranteeResponsibleName,
                    isLoadingWarranty: false,
                });
            }
            return _.assign({}, element);
        })

        return _.assign({}, state, { productsList: hardwareList });
    },
    [types.FETCH_SMB2_FIRMWARE_VERSION_BY_SERIAL_SUCCESS](state, action) {
            const hardwareList = state.productsList.map(element => {
                if (element.serialNumber === action.response.serialNumber) {
                   return _.assign({}, element, {
                        smb2FirmwareVersion: action.response.smb2FirmwareVersion,
                        isLoadingSmb2FirmwareVersion: false,
                    });
                }
                return _.assign({}, element);
            })

            return _.assign({}, state, { productsList: hardwareList });
        },

});
export default reducer;